import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, from, of, throwError } from 'rxjs';
import { concatMap, retryWhen, delay, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private header: any;

  constructor(
    private http: HttpClient,
  ) { 
    this.header = {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    }
  }

  uploadSendGridAttachments(payloadAttachment): Observable<any> {
    return this.getEmailPreSignedURL(payloadAttachment.get("content")).pipe(

      switchMap((preSignedUrlRes: any[]) => {
        return this.uploadEmailAttachments(preSignedUrlRes, payloadAttachment).pipe(
          
          switchMap(() => {
            return this.checkAttachmentUploadStatusWithRetry(preSignedUrlRes['transactionId'], 10);
          })
        );
      })
    );
  }

  createSendGridUploadDocsPayload(files: File[]): Promise<any[] | null> {
    return Promise.all(files.map(file =>
      this.convertFileToBase64(file).then(base64Str => ({
        content: (base64Str && typeof base64Str === 'string') ? base64Str.split(',')[1] : base64Str,
        type: 'application/pdf',
        filename: file.name,
        disposition: 'attachment'
      }))));
  }

  convertFileToBase64(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
    const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

  getEmailPreSignedURL(emailPayload: any): Observable<any> {
    const url = `${environment.backend_server_url_policy}/sendGrid/preSignedUrl`;
    // const url = `/personal-policy-api/sendGrid/preSignedUrl`;
    return this.http.post(url, emailPayload, this.header);
  }

  uploadEmailAttachments(preSignedURLObj: any, payloadAttachment: any): Observable<any> {
    const files: File[] = payloadAttachment.getAll("attachments") as File[]
    const isSuccess = preSignedURLObj['successStatus']
      if(isSuccess){
        return from(this.createSendGridUploadDocsPayload(files)).pipe(

          switchMap(payload => {
            return this.http.put(preSignedURLObj['signedUrl'], payload, this.header);
          }))
      } else {
        return throwError(() => new Error('Error while getting pre-signed URL'))
      }
  }

  checkAttachmentUploadStatusWithRetry(transactionId: string, retryNum): Observable<any> {
    const url = `${environment.backend_server_url_policy}/sendGrid/upload-status/${transactionId}`;
    return this.http.get(url).pipe(
      switchMap(status => {
        if(status === 'CREATE_PRESIGN' || status === 'IN_PROCESS'){
          return throwError(() => new Error("Upload Status is not COMPLETE"))
        }else{
          return of(status)
        }
      }),

      retryWhen(errors => errors.pipe(
        concatMap((e, index) => {
          if(index === retryNum)
           throwError(e)
          
           console.log(`Retrying check upload status... Attempt ${index + 1}`);
            return of(e).pipe(delay((index + 1) * 2000));
          }),
      )),
    );
  }
}